// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretUpOutlinedSvg from "@fishx/icons-svg/es/asn/CaretUpOutlined";
import FishxIcon from '../components/FishxIcon';

var CaretUpOutlined = function CaretUpOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretUpOutlinedSvg
  }));
};

CaretUpOutlined.displayName = 'CaretUpOutlined';
export default React.forwardRef(CaretUpOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CaretUpOutlined.js
// module id = 2182
// module chunks = 0